import React from 'react'
import { ModalDescription } from 'src/Modal/styles'
import { HUBSPOT } from 'src/Utils/hubspot/hubspot.utils'
import { P } from 'src/components/Reusable/Text/Text.styles'
import palette from 'src/designSystem/variables/palette'
import { MessageType } from 'src/components/Reusable/Message/Message.constants'
import { Message } from 'src/components/Reusable/Message/Message'

export const AdditionalControlDetails = ({
  isEmptyAccount,
}: {
  isEmptyAccount: boolean
}): JSX.Element =>
  isEmptyAccount ? (
    <></>
  ) : (
    <>
      <span>
        Upload a CSV or XLSX file of all your controls. The system will
      </span>
      <ul>
        <li>delete all existing controls and linkages</li>
        <li>
          create controls and linkages to policies and frameworks from your file
        </li>
        <li>links to evidence are not part of the control export file</li>
        <li>
          replace each control&apos;s risks with what its Risks cell lists — a
          file with no Risks column leaves your risk mappings alone
        </li>
      </ul>
      <Message
        messageType={MessageType.INFO}
        messageText={`This will remove all controls currently in your account, including all links to evidence. If you’re
            just starting out, that’s great! If you’re further along, be
            cautious!`}
      />
    </>
  )

export const ControlResponsibilityDescription = ({
  isNaStatus,
}: {
  isNaStatus: boolean
}): JSX.Element => (
  <ModalDescription>
    Read more about determining control responsibility in our{' '}
    <a href={HUBSPOT.CONTROL_RESPONSIBILITY} target="_blank" rel="noreferrer">
      Knowledge Base.
    </a>
    <P $color={palette.orange[900]}>
      {isNaStatus
        ? `Note: Control Status will also be updated to "Not Applicable"`
        : `Note: Control Status will also be updated to "Needs Attention"`}
    </P>
  </ModalDescription>
)
